import { useLocation } from 'react-router-dom';

function ThankYou() {
  const location = useLocation();
  const state = location.state as { responseType?: string; campaignName?: string } | null;

  const isInterested = state?.responseType === 'interested' || state?.responseType === 'need_info';

  return (
    <div className="thank-you-container">
      <div className="thank-you-icon">&#10003;</div>
      <h1>Thank You!</h1>

      {isInterested ? (
        <>
          <p>
            Your response has been recorded. A member of our research team will be in touch
            with you soon to discuss the next steps.
          </p>
          <div className="thank-you-note">
            <strong>What happens next?</strong>
            <br />
            We'll review your response and contact you within a few business days to answer
            any questions and discuss your potential participation.
          </div>
        </>
      ) : (
        <>
          <p>
            Your response has been recorded. Thank you for letting us know.
          </p>
          <div className="thank-you-note">
            If you change your mind in the future, you're always welcome to contact us about
            participating in research studies.
          </div>
        </>
      )}
    </div>
  );
}

export default ThankYou;
